'use client'

import { cn } from '@/lib/utils'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

export default function DriverTabs({}) {
  const pathname = usePathname()

  return (
    <div
      className={cn(
        'no-scrollbar col-span-full col-start-1 -mx-3 my-7 flex items-baseline overflow-x-auto border-b border-neutral-blue-700',
      )}
    >
      {[
        {
          tabName: 'calendar',
          tabTitle: 'My Race Calendar',
        },
        {
          tabName: 'my-liveries',
          tabTitle: 'Livery Collection',
        },
        // { tabName: 'my-leagues', tabTitle: 'My Leagues' },
        //{ tabName: 'report', tabTitle: 'Driver Report' },
      ].map((tabOption) => (
        <Link
          key={`tab-option-${tabOption.tabTitle}`}
          href={`/profile-manager/driver/${tabOption.tabName}`}
          className={cn(
            'mx-3 cursor-pointer whitespace-nowrap pb-2 text-p-1 transition-all desktop-sm:text-p-2',
            pathname.split('/').at(-1) === tabOption.tabName ||
              (tabOption.tabName === 'calendar' &&
                !pathname.split('driver').at(-1))
              ? 'border-b-2 border-primary text-shades-0'
              : 'text-neutral-blue-500 hover:text-shades-0',
          )}
        >
          {tabOption.tabTitle}
        </Link>
      ))}
    </div>
  )
}
